var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { RichText as ReactRichText, RichTextPropTypes, } from '@sitecore-jss/sitecore-jss-react';
const prefetched = {};
export const RichText = (props) => {
    const { internalLinksSelector = 'a[href^="/"]' } = props, rest = __rest(props, ["internalLinksSelector"]);
    const hasText = props.field && props.field.value;
    const isEditing = props.editable && props.field && props.field.editable;
    const router = useRouter();
    const richTextRef = useRef(null);
    useEffect(() => {
        // NOT IN EXPERIENCE EDITOR
        if (hasText && !isEditing) {
            initializeLinks();
        }
    }, []);
    const routeHandler = (ev) => {
        if (!ev.target)
            return;
        ev.preventDefault();
        const pathname = ev.target.href;
        router.push(pathname, pathname, { locale: false });
    };
    const initializeLinks = () => {
        const node = richTextRef.current;
        // selects all links that start with '/'
        const internalLinks = node && node.querySelectorAll(internalLinksSelector);
        if (!internalLinks || !internalLinks.length)
            return;
        internalLinks.forEach((link) => {
            if (link.target !== '_blank') {
                if (!prefetched[link.pathname]) {
                    router.prefetch(link.pathname, undefined, { locale: false });
                    prefetched[link.pathname] = true;
                }
                link.addEventListener('click', routeHandler, false);
            }
        });
    };
    return React.createElement(ReactRichText, Object.assign({ ref: richTextRef }, rest));
};
RichText.propTypes = Object.assign({ internalLinksSelector: PropTypes.string }, RichTextPropTypes);
RichText.defaultProps = {
    tag: 'div',
    editable: true,
};
RichText.displayName = 'NextRichText';
